import React, { useState } from "react";
import classnames from "class-names";
import CalendarFilter from "./../Filter/CalendarFilter";
import { format } from "date-fns";
import { ru } from "date-fns/locale";
import DropdownFilter from "../Filter/DropdownFilter";

const time = {
  0: "Любое",
  1: "с 8:00 до 11:00",
  2: "с 11:00 до 14:00",
  3: "с 14:00 до 17:00",
  4: "с 17:00 до 20:00"
};

const DateTimeSelect = ({ className, scheduledTime, scheduledDay }) => {
  const [appointmentDay, setAppointmentDay] = useState(scheduledDay || format(new Date(), 'EEEE, d MMMM', { locale: ru }));
  const [appointmentTime, setAppointmentTime] = useState(scheduledTime || time[0]);

  const changeTime = e => {
    if (!e.target.textContent.includes('Выберите желаемое время')) {
      const scheduledTimeForm = document.querySelector('.appointment_scheduled_time');
      const scheduledTimeSidebar = document.querySelector('.appointment-info-card__label-time');

      scheduledTimeSidebar.textContent = e.target.textContent;
      scheduledTimeForm.value = e.target.textContent;
      setAppointmentTime(e.target.textContent);
    }
  };

  const changeDay = e => {
    const scheduledDayForm = document.querySelector('.appointment_scheduled_day');
    const scheduledDaySidebar = document.querySelector('.appointment-info-card__label-day');
    const date = e.target.getAttribute('aria-label');
    const dateFormat = 'EEEE, d MMMM';
    const selectedDay = format(new Date(date), dateFormat, { locale: ru })

    if (selectedDay != 'четверг, 1 января') {
      scheduledDaySidebar.textContent = selectedDay;
      scheduledDayForm.value = selectedDay;
      setAppointmentDay(selectedDay);
    }
  };

  return (
    <div className={classnames("date-selector", className)}>
      <div onClick={changeDay} className="date-selector__calendar-wrapper">
        <CalendarFilter
          title="Выберите дату"
          className="appointment-form__filter"
          defaultValue={new Date()}
          getTitle={day => appointmentDay}
        />
      </div>
      <div onClick={changeTime} className="date-selector__slots-wrapper date-selector__slots-wrapper_space-v_none date-selector__slots-wrapper_space-h_none">
        <DropdownFilter
          name="time"
          className="appointment-form__filter"
          getTitle={value => appointmentTime}
          title="Выберите желаемое время"
          values={time}
          defaultValue={0}
        />
      </div>
    </div>
  )
};

export default DateTimeSelect;
